// Lightweight video prefetch utility
// Provides two functions:
// - prefetchVideos(urls, { useFetch }) : inserts <link rel="preload"> tags for given video URLs and optionally issues small ranged fetches to warm the cache.
// - prefetchPortfolioVideos(): convenience wrapper for the project's portfolio video list.

export function prefetchVideos(urls = [], options = {}) {
  const { useFetch = false, mimeType = "video/mp4" } = options;

  if (!Array.isArray(urls) || urls.length === 0) return;

  urls.forEach((u) => {
    try {
      // Normalize to absolute path if caller passed relative paths
      const href = u.startsWith("/") ? u : `/${u.replace(/^\.\//, "")}`;

      // Avoid duplicating link tags
      const exists = Array.from(
        document.querySelectorAll('link[rel="preload"]')
      ).some((l) => l.getAttribute("href") === href);
      if (!exists) {
        const l = document.createElement("link");
        l.rel = "preload";
        l.as = "video";
        l.href = href;
        l.type = mimeType;
        // crossorigin can help if the asset is hosted on a CDN and requires CORS
        l.crossOrigin = "anonymous";
        document.head.appendChild(l);
      }

      if (useFetch && window.fetch) {
        // Try to fetch only the first few KB to warm the browser cache without downloading full asset
        // Note: server must support Range requests for this to be efficient; otherwise this fetch may download full file.
        fetch(href, {
          method: "GET",
          headers: { Range: "bytes=0-32767" },
          mode: "cors",
          credentials: "same-origin",
        }).catch(() => {
          // ignore fetch errors
        });
      }
    } catch (e) {
      // ignore any DOM errors
    }
  });
}

export function prefetchPortfolioVideos(opts = {}) {
  // List of portfolio video paths (root-relative). Keep this list small to avoid bandwidth spikes.
  const urls = [
    "/Imgs/WalksOfLight/Walks of light.MP4",
    "/Imgs/WalksOfLight/Walks of light - Rafael (Directing).MP4",
    "/Imgs/WalksOfLight/time square - wol.mov",
    "/Imgs/WalksOfLight/behind the scenes -walks of light.mov",
    "/Imgs/ParksNYC/GCM Productions_ParkNYC_no cc, but embeded.mov",
    "/Imgs/WhatIf/WhatIfTrailerSMALLER.mp4",
    "/Imgs/SnowInterview/CLIP INTERVIEW SNOW.MP4",
  ];
  prefetchVideos(urls, opts);
}

export default prefetchVideos;
